import type { DOT_COLOR } from 'cpool-constants';
import { DOT_COLORS } from 'cpool-constants';
import { SchemaLoanRequestResolver_Get, SchemaLoanRequestResolver_GetSummary } from 'cpool-tables/backend-resolvers';
import type { TFunction } from 'i18next';
import { LuFileSearch } from 'react-icons/lu';
import { LeadTraitInfo, SchufaSource } from '~/types/LeadTraits';

export const getSchufaInfo = (
    lead: SchemaLoanRequestResolver_GetSummary[number] | SchemaLoanRequestResolver_Get,
    schufaSource: SchufaSource | null,
    t: TFunction<'de' | 'en', undefined>,
): LeadTraitInfo => {
    if (!schufaSource) return null;

    let schufaColor: DOT_COLOR = DOT_COLORS.YELLOW;

    if (lead.applicant1SchufaScore === 0 && lead.applicant2SchufaScore !== 1) {
        // Negative
        schufaColor = DOT_COLORS.RED;
    } else if (lead.applicant1SchufaScore === 1 || lead.applicant2SchufaScore === 1) {
        // Positive
        schufaColor = DOT_COLORS.GREEN;
    }

    const schufaScore =
        'applicantId' in schufaSource
            ? schufaSource.consorsResponse?.schufaInfo?.schufaKopf?.schufaScore
            : schufaSource.schufaScore;

    return {
        dot: schufaColor,
        dotText: schufaScore,
        Icon: LuFileSearch,
        text: t('LEADS.TRAIT.SCHUFA'),
    };
};
